import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './Context/AuthContext';
import { Navbar } from "./components/navbar";
import 'react-toastify/dist/ReactToastify.css';
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
 <AuthProvider>
    <App /> 
    </AuthProvider>
  </React.StrictMode>
);
